import { Enrollee } from "pmt-types/src/models/Enrollee.ts";
import { useQuery } from "react-query";
import { Maybe } from "../../utils/types/maybe.ts";
import { useAuthentication } from "../useAuthentication.ts";
import { QueryKeys } from "./queryKeys.ts";

export const useQueryGetEnrolleeById = (
  sourceId: Maybe<string>,
  projectId: Maybe<string>,
  enrolleeId: Maybe<string>,
) => {
  const { accessToken } = useAuthentication();

  return useQuery(
    [QueryKeys.GetEnrollees, enrolleeId],
    async () => {
      const response = await fetch(
        `${
          import.meta.env.VITE_API_HOST
        }/sources/${sourceId}/projects/${projectId}/enrollees/${enrolleeId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to query enrollee");
      }

      return (await response.json()) as Enrollee;
    },
    {
      enabled:
        sourceId != null &&
        projectId != null &&
        enrolleeId != null &&
        enrolleeId != "new",
      onError: (error) => {
        console.error("Failed to get enrollee", error, enrolleeId);
      },
    },
  );
};
